import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Typography,
} from "@mui/material";
import { getDeliveryStatus } from "../../../utils/functions";

/**
 * Modal to change status to selected deliveries
 * @param {object} props
 * @param {boolean} props.open - Controls if the modal is open
 * @param {function} props.onClose - Function to call when the modal closes
 * @param {function(string, string): void} props.onConfirm - Function called with the selected deliveries and status/sub-status to change
 * @param {boolean} [props.loading=false] - Shows a loading state
 */

const ChangeStatusModal = ({
  open,
  onConfirm,
  onClose,
  loading = false,
}) => {
  const [statuses] = useState(getDeliveryStatus());
  const [substatuses, setSubStatuses] = useState([]);
  const [status, setStatus] = useState("");
  const [subStatus, setSubStatus] = useState("");

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
    const currentStatus = statuses.find(
      (status) => status.system_name === event.target.value
    );
    setSubStatuses(currentStatus.substatus);
  };

  const handleConfirm = () => {
    if (status !== "" && subStatus !== "") {
      onConfirm(status, subStatus);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Modificar estados de envíos seleccionados</DialogTitle>
      <Typography variant="body2" color="text.secondary" sx={{pr: 3, pl: 3}}>Selecciona los estados y subestados a asignar a los envíos marcados.</Typography>
      <DialogContent sx={{ width: '100%' }}>
        <FormControl fullWidth>
          <InputLabel id="status">Seleccionar Estado</InputLabel>
          <Select
            labelId="status"
            id="status"
            value={status}
            label="Seleccionar Estado"
            onChange={handleStatusChange}
          >
            {statuses.map((status) => (
              <MenuItem
                value={status.system_name}
                key={`status-${status.system_name}-${status.id}`}
              >
                {status.user_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {substatuses.length > 0 ? (
          <FormControl fullWidth>
            <InputLabel id="substatus">Seleccionar Sub Estado</InputLabel>
            <Select
              labelId="substatus"
              id="substatus"
              value={subStatus}
              label="Seleccionar Sub Estado"
              onChange={(event) => setSubStatus(event.target.value)}
            >
              {substatuses.map((substatus) => (
                <MenuItem
                  value={substatus.system_name}
                  key={`substatus-${substatus.system_name}-${substatus.id}`}
                >
                  {substatus.user_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={!status || !subStatus || loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeStatusModal;
